import { Icon } from "@/ds";

import { ConflitoGanttSecao } from "../../../conflito-gantt-secao";
import { ConflitoJustificativa } from "../../../conflito-justificativa";
import { GanttProfissionais } from "@/shared/components/gantt-profissionais";
import { ALOCACAO_SECTION_LABEL } from "../../resolver-conflito-fornecedor.constants";
import styles from "./revisao-fornecedor-step.module.scss";
import type { RevisaoFornecedorStepViewModel } from "./types-revisao-fornecedor-step";

export function RevisaoFornecedorStepView({
  fornecedorNome,
  substitutoNome,
  escopo,
  obraRotulo,
  continuaEm,
  legenda,
  rows,
  timeline,
  today,
  disabled,
  justificativa,
}: RevisaoFornecedorStepViewModel) {
  return (
    <>
      <p className={styles.resumo} data-testid="resolver-conflito-revisao-resumo">
        O fornecedor <strong>{fornecedorNome}</strong> será substituído por{" "}
        <strong>{substitutoNome}</strong>
        {escopo ? (
          <>
            {" "}
            no escopo <strong>{escopo}</strong> da
          </>
        ) : (
          " na"
        )}{" "}
        <strong>{obraRotulo}</strong>.
      </p>

      {continuaEm ? (
        <p className={styles.nota} data-testid="resolver-conflito-revisao-note">
          <Icon name="exclamation-triangle" size={10.5} />
          <span>{continuaEm}</span>
        </p>
      ) : null}

      <ConflitoGanttSecao titulo={ALOCACAO_SECTION_LABEL} legenda={legenda}>
        <GanttProfissionais
          rows={rows}
          timeline={timeline}
          today={today}
          headerLabel="Fornecedor"
        />
      </ConflitoGanttSecao>

      <ConflitoJustificativa
        id="resolver-conflito-justificativa"
        value={justificativa.value}
        onChange={justificativa.alterar}
        error={justificativa.error}
        disabled={disabled}
        divided
        testId="resolver-conflito-justificativa"
        maxLength={justificativa.maxLength}
      />
    </>
  );
}
